// src/store/appointmentsSlice.js
import { createSlice } from "@reduxjs/toolkit";

const appointmentsSlice = createSlice({
  name: "appointments",
  initialState: {
    pendingAppointments: [],
  },
  reducers: {
    setPendingAppointments(state, action) {
      state.pendingAppointments = action.payload;
    },
    clearPendingAppointments(state) {
      state.pendingAppointments = [];
    },
  },
});

export const {
  setPendingAppointments,
  clearPendingAppointments,
} = appointmentsSlice.actions;

export default appointmentsSlice.reducer;
